import { render, staticRenderFns } from "./seWorkspace.vue?vue&type=template&id=5b0f72fe&scoped=true&"
import script from "./seWorkspace.vue?vue&type=script&lang=js&"
export * from "./seWorkspace.vue?vue&type=script&lang=js&"
import style0 from "./seWorkspace.vue?vue&type=style&index=0&id=5b0f72fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0f72fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b0f72fe')) {
      api.createRecord('5b0f72fe', component.options)
    } else {
      api.reload('5b0f72fe', component.options)
    }
    module.hot.accept("./seWorkspace.vue?vue&type=template&id=5b0f72fe&scoped=true&", function () {
      api.rerender('5b0f72fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/DestinationBusiness/detail/seWorkspace.vue"
export default component.exports